<template>
  <div :id="overlay ? 'spinnerwrap' : 'container'" v-show="visible">
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    overlay: { type: Boolean, default: false },
    visible: { type: Boolean, required: true },
  },
};
</script>

<style lang="scss" scoped>
#spinnerwrap {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 100;
  & > .spinner {
    display: flex;
    margin: 0 auto;
  }
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 3px solid #f25a41;
  border-radius: 100%;
  margin: auto;
  animation: spin 1s infinite linear;
  margin: 8px;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
